module.exports = __webpack_public_path__ + "product-espressosmart-medium.6ad90ee0.jpg";